/* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ToolbarDropdownMenu.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import DropdownMenu from '@atlaskit/dropdown-menu';
import { useToolbarUI } from '../hooks/ui-context';
import { ToolbarButton } from './ToolbarButton';
import { ToolbarDropdownMenuProvider, useToolbarDropdownMenu } from './ToolbarDropdownMenuContext';
var styles = {
  sectionMargin: "_1mou1b66"
};
var ToolbarDropdownMenuContent = function ToolbarDropdownMenuContent(_ref) {
  var iconBefore = _ref.iconBefore,
    children = _ref.children,
    isDisabled = _ref.isDisabled,
    testId = _ref.testId,
    label = _ref.label;
  var _useToolbarUI = useToolbarUI(),
    onDropdownOpenChanged = _useToolbarUI.onDropdownOpenChanged;
  var _useToolbarDropdownMe = useToolbarDropdownMenu(),
    closeMenu = _useToolbarDropdownMe.closeMenu,
    isOpen = _useToolbarDropdownMe.isOpen,
    openMenu = _useToolbarDropdownMe.openMenu;
  var handleOpenChange = useCallback(function (args) {
    onDropdownOpenChanged(args);
    if (!args.isOpen) {
      closeMenu();
    }
  }, [closeMenu, onDropdownOpenChanged]);
  var handleClick = useCallback(function () {
    if (!isOpen) {
      openMenu();
    } else {
      closeMenu();
    }
  }, [closeMenu, openMenu, isOpen]);
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(ToolbarButton, {
        ref: triggerProps.triggerRef,
        isSelected: triggerProps.isSelected,
        "aria-expanded": triggerProps['aria-expanded'],
        "aria-haspopup": triggerProps['aria-haspopup'],
        "aria-controls": triggerProps['aria-controls'],
        onBlur: triggerProps.onBlur,
        onClick: function onClick(e) {
          handleClick();
          triggerProps.onClick && triggerProps.onClick(e);
        },
        onFocus: triggerProps.onFocus,
        testId: testId,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        label: label
      });
    },
    onOpenChange: handleOpenChange,
    isOpen: isOpen
  }, children);
};
export var ToolbarDropdownMenu = function ToolbarDropdownMenu(_ref2) {
  var iconBefore = _ref2.iconBefore,
    children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    testId = _ref2.testId,
    label = _ref2.label,
    _ref2$hasSectionMargi = _ref2.hasSectionMargin,
    hasSectionMargin = _ref2$hasSectionMargi === void 0 ? true : _ref2$hasSectionMargi;
  return /*#__PURE__*/React.createElement(ToolbarDropdownMenuProvider, null, /*#__PURE__*/React.createElement(ToolbarDropdownMenuContent, {
    iconBefore: iconBefore,
    isDisabled: isDisabled,
    testId: testId,
    label: label
  }, /*#__PURE__*/React.createElement("div", {
    className: ax([hasSectionMargin && styles.sectionMargin])
  }, children)));
};